/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useStyles } from './style';




const Footer = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      {/* <Typography variant="body1">
        &copy;{" "}
        <Link component="a" href="https://www.bpi.ir/" target="_blank">
          نسخه
        </Link>
        . 0.1.0
      </Typography>
      <Typography variant="caption">
        کلیه حقوق وب سایت متعلق به بانک{" "}
        <Link component="a" href="https://www.bpi.ir/" target="_blank">
          پاسارگاد
        </Link>{" "}
        می باشد.
      </Typography> */}
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
